import React, { Fragment } from 'react';
import Menu from '@mui/material/Menu';
import { IconButton } from '@mui/material';
import MenuIcon from '../icon/MenuIcon';
import Label from './Label';

function SimpleMenu(props) {
    const { children } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <Fragment>
            <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} size="large">
                <div style={{ display: 'flex', alignSelf: 'center' }}>
                    <MenuIcon />
                    <Label>More</Label>
                </div>
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl || null}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className="simple-menu"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                {children}
            </Menu>
        </Fragment>
    );
}

export default SimpleMenu;
